export const validatePasswordMatching = values => {
  const errors = {}
  if (values.password1 !== values.password2)
    errors.password2 = "passwords don't match"
  return errors
}

export default { validatePasswordMatching }
